import { render, staticRenderFns } from "./PatientErrorModal.vue?vue&type=template&id=083bc06e&scoped=true&"
import script from "./PatientErrorModal.vue?vue&type=script&lang=js&"
export * from "./PatientErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083bc06e",
  null
  
)

export default component.exports